module.exports = __webpack_public_path__ + "static/media/emailIcon.569a1b39.svg";